import { render, staticRenderFns } from "./ImpressumPage.vue?vue&type=template&id=26111441&"
import script from "./ImpressumPage.vue?vue&type=script&lang=js&"
export * from "./ImpressumPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports